"use strict";

function closeCookies() {
  document.getElementById('js-cookies').classList.remove('is-display');
  Cookies.set('cookies-accepted', '1', {
    expires: 365
  });
}

function initCookies() {
  if (Cookies.get('cookies-accepted') != 1) {
    setTimeout(function () {
      document.getElementById('js-cookies').classList.add('is-display');
    }, 1500);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var cookies = document.getElementById('js-cookies');

  if (cookies) {
    initCookies();
  }
});